import React, { useEffect, useContext } from "react";
import styled from "styled-components";

import UIManager from "../service/ui-manager";
import { UIStateContext } from "../provider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Row, Text } from "../comps";
import { Z_INDEX, SCREEN_TYPE } from "../constants";
import { Theme } from "../theme/theme-provider";

import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

const Wrapper = styled(Row)`
  position: fixed;
  width: 100vw;
  height: 100vh;
  align-items: center;
  background: ${({ theme }) => theme.color.BLACK_1};
  z-index: ${Z_INDEX.modal};
  justify-content: center;
`;

export default () => {
  const [UIState, setUIState] = useContext(UIStateContext);
  const { screen } = UIState;

  useEffect(() => {
    UIManager.register(setUIState);
  }, []);

  return screen === SCREEN_TYPE.NOT_SUPPORTED ? (
    <Wrapper>
      <Row alignItems="center">
        <FontAwesomeIcon
          style={{
            fontSize: "20px",
            color: Theme.color.GRAY_1,
            margin: "5px",
          }}
          icon={faInfoCircle}
        />
        <Text
          color={Theme.color.GRAY_0}
          fontSize="18px"
          textAlign="left"
          marginLeft="8px"
        >
          {`Screen size not supported!`}
        </Text>
      </Row>
    </Wrapper>
  ) : (
    <></>
  );
};
